export default __webpack_public_path__ + "static/media/Goldman-Bold.7433bf92.ttf";